import { render, staticRenderFns } from "./PerguntasDuplicadas.vue?vue&type=template&id=562f789a"
import script from "./PerguntasDuplicadas.vue?vue&type=script&lang=ts"
export * from "./PerguntasDuplicadas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports